module.exports = __webpack_public_path__ + "static/media/so.40cc58ef.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/so.svg
// module id = 2212
// module chunks = 0